import {getJson, deleteJson, patchJson, postJson, putJson} from '@/util/ajaxUtils';
import {API_ROOT} from '@/env';

export function getClientAppPage(current, size) {
    return getJson(`${API_ROOT}/clientapps`, {params: {current, size}});
}

export function getClientAppPageUrl() {
    return `${API_ROOT}/clientapps`;
}

export function getClientApp(id) {
    return getJson(`/clientapps/${id}`);
}

export function addClientApp(clientApp) {
    return postJson(`/clientapps`, {data: clientApp});
}

// 废弃
// export function updateClientApp(id, clientApp) {
//     return putJson(`/clientapps/${id}`, {data: clientApp});
// }

export function patchClientApp(id, data) {
    return patchJson(`/clientapps/${id}`, {data});
}

export function deleteClientApp(id) {
    return deleteJson(`/clientapps/${id}`);
}

export function regenerateSignKey(id) {
    return patchJson(`/clientapps/${id}/signkey`);
}

export function getTicketUrl(id, destUrl) {
    return getJson(`/clientapps/${id}/ticket-url`, {params: {destUrl}});
}

export function getApiList() {
    return getJson('/clientapps/apis');
}

export function getGlobalAllows(id) {
    return getJson(`/clientapps/${id}/global-allows`);
}

export function saveGlobalAllows(id, allows) {
    return postJson(`/clientapps/${id}/global-allows`, {data: allows});
}

export function getApiLinks(id, activeKey) {
    return getJson(`/clientapps/${id}/apilinks/${activeKey}`);
}

export function saveApiLinks(id, apiIds, activeKey) {
    return postJson(`/clientapps/${id}/apilinks/${activeKey}`, {data: apiIds || []});
}

export function updateApiLink(id, linkId, link) {
    return putJson(`/clientapps/${id}/apilinks/${linkId}`, {data: link});
}

export function updateAppLinkAllows(id, linkId, allows) {
    return putJson(`/clientapps/${id}/apilinks/${linkId}/allows`, {data: allows});
}

export function deleteApiLink(id, linkId) {
    return deleteJson(`/clientapps/${id}/apilinks/${linkId}`);
}
